import React, { useState, useEffect } from 'react';
import { Routes, Route } from "react-router-dom";


import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./assets/css/animated.css";
import "./assets/css/style.css";
import "./assets/css/icons.css";
import "./assets/iconfonts/feather/feather.css";
import "./assets/switcher/css/switcher.css";
import "./assets/switcher/demo.css";

import './assets/fonts/font.css'
import "./assets/style/style.css";
import "./assets/style/responsive.css";
import 'react-toastify/dist/ReactToastify.css';
import 'ckeditor5/ckeditor5.css';
import Login from './auth/Login';


import Header from './includes/Header';
import Dashboard from './pages/Dashboard/Dashboard';
import Leads from './pages/Leads/Leads';
import Organization from './pages/Organization/Organization';
import QuotationTracking from './pages/QuotationTracking/QuotationTracking';
import Client from './pages/Organization/Client';
import VendorsPartner from './pages/Organization/VendorsPartner';
import AssociatePartner from './pages/Organization/AssociatePartner';
import ChannelPartner from './pages/Organization/ChannelPartner';
import BillingEntity from './pages/Organization/BillingEntity';

import Employee from './pages/Employee/Employee';

import ChannelPartners from './pages/ChannelPartners/ChannelPartners';
import Projects from './pages/Projects/Projects';
import Invoices from './pages/Invoices/Invoices';
import CommunicatinLog from './pages/CommunicatinLog/CommunicatinLog';
import MailTemplates from './pages/MailTemplates/MailTemplates';
import Error from './pages/Error/Error';

import Activity from './pages/Masters/Activity';
import ActivityTemplate from './pages/Masters/ActivityTemplate';
import CommunicationType from './pages/Masters/CommunicationType';
import Sectors from './pages/Masters/Sectors';
import SubSectors from './pages/Masters/SubSectors';
import OrganiztionType from './pages/Masters/OrganiztionType';
import OrganizationStage from './pages/Masters/OrganizationStage';
import Functions from './pages/Masters/Functions';
import Designation from './pages/Masters/Designation';

import DocumentType from './pages/Masters/DocumentType';
import Role from './pages/Masters/Role';
import Master from './pages/Master/Master';
import SubMaster from './pages/Master/SubMaster'
import Campaigns from './pages/Campaigns/Campaigns';


import ProjectCategory from './pages/Masters/Projects/ProjectCategory';
import ProductCategory from './pages/Masters/Projects/ProductCategory';
import ProductSubCategory from './pages/Masters/Projects/ProductSubCategory';
import Products from './pages/Masters/Projects/Products';

import PaymentDue from './pages/PaymentDue/PaymentDue';


const Main = () => {
  const [isLogin, setIsLogin] = useState(false);
  useEffect(() => {
    if (localStorage.getItem('useToken')) {
      setIsLogin(true);
    }
    else {
      setIsLogin(false);
    }
  }, [])
  return (
    <>
      {isLogin ?
        <div className='horizontalMenucontainer'>
          <div className='page'>
            <div className='page-main'>
              <Header />
              <div className='main-content app-content mt-0'>
                <div className='side-app'>
                  <div className='main-container container-fluid'>
                    <React.Fragment>
                      <Routes>
                        {/* <Route exact path="/" element={<Dashboard />} /> */}
                        <Route exact path="/" element={<Leads />} />
                        <Route exact path="/leads" element={<Leads />} />
                        <Route exact path="/organization" element={<Organization />} />
                        <Route exact path="/org-module/client" element={<Client />} />
                        <Route exact path="/org-module/vendors-partner" element={<VendorsPartner />} />
                        <Route exact path="/org-module/associate-partner" element={<AssociatePartner />} />
                        <Route exact path="/org-module/channel-partner" element={<ChannelPartner />} />
                        <Route exact path="/org-module/billing-entity" element={<BillingEntity />} />

                        <Route exact path="/campaigns" element={<Campaigns />} />
                        <Route exact path="/employee" element={<Employee />} />

                        <Route exact path="/quotation" element={<QuotationTracking />} />
                        <Route exact path="/channel-partners" element={<ChannelPartners />} />
                        <Route exact path="/projects" element={<Projects />} />
                        <Route exact path="/invoices" element={<Invoices />} />
                        <Route exact path="/communicatin-log" element={<CommunicatinLog />} />

                        <Route exact path="/master" element={<Master />} />
                        <Route exact path="/master/subMaster/:typeId" element={<SubMaster />} />
                        <Route exact path="/masters/products" element={<Products />} />
                        <Route exact path="/masters/activity" element={<Activity />} />
                        <Route exact path="/masters/activity-template" element={<ActivityTemplate />} />
                        <Route exact path="/masters/communication-type" element={<CommunicationType />} />

                        <Route exact path="/masters/organiztion-type" element={<OrganiztionType />} />
                        <Route exact path="/masters/organization-stage" element={<OrganizationStage />} />
                        <Route exact path="/masters/sectors" element={<Sectors />} />
                        <Route exact path="/masters/sectors/:id" element={<SubSectors />} />
                        <Route exact path="/masters/product-category" element={<ProductCategory />} />
                        <Route exact path="/masters/product-category/:id" element={<ProductSubCategory />} />
                        <Route exact path="/masters/role" element={<Role />} />
                        <Route exact path="/masters/functions" element={<Functions />} />
                        <Route exact path="/masters/designation/:id" element={<Designation />} />
                        <Route exact path="/masters/document-type" element={<DocumentType />} />

                        <Route exact path="/masters/project-category" element={<ProjectCategory />} />

                        <Route exact path="/mail-templates" element={<MailTemplates />} />
                        <Route exact path="/payment-due" element={<PaymentDue />} />

                        <Route exact path="*" element={<Error />} />
                      </Routes>
                    </React.Fragment>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        :
        <React.Fragment>
          <Routes>
            <Route exact path="/" element={<Login />} />
            <Route exact path="*" element={<Error />} />
          </Routes>
        </React.Fragment>
      }
    </>
  );
}

export default Main